<template>
  <div class="navbar">
    <div>
      <hamburger id="hamburger-container" :is-active="sidebar.opened"
                 class="hamburger-container"
                 @toggleClick="toggleSideBar"/>
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>
    </div>
    <div class="adv">
    </div>
    <div class="right-menu">
      <div>
        <el-dropdown :hide-on-click="false" @command="doAction">
        <span class="el-dropdown-link">
          {{ admin.username }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updatePassword">{{ $t('message.sys.admin.updatePassword') }}</el-dropdown-item>
            <el-dropdown-item command="logout" divided>{{ $t('message.sys.admin.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <language customClass="lang-wrapper" fontColor="#3B82F6"></language>
    </div>
    <el-dialog
      :title="$t('message.sys.admin.updatePassword')"
      v-if="visible.updatePassword"
      :visible.sync="visible.updatePassword"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="500px"
      center>
      <el-form ref="updatePasswordForm" :model="updatePassword" :rules="updatePasswordRules" label-width="80px">
        <el-form-item :label="$t('message.sys.admin.originPassword')" prop="oldPassword">
          <el-input v-model="updatePassword.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.sys.admin.newPassword')" prop="newPassword">
          <el-input
            ref="password"
            v-model="updatePassword.newPassword"
            name="text"
            :type="newPasswordType"
            @keyup.enter.native="doUpdatePassword"
          />
          <span class="show-pwd" @click="showPwd('newPassword')">
              <svg-icon
                :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
              />
            </span>
        </el-form-item>
        <el-form-item :label="$t('message.sys.admin.confirmPassword')" prop="repeatPassword">
          <el-input
            ref="repeatPassword"
            v-model="updatePassword.repeatPassword"
            name="text"
            :type="repeatPasswordType"
            @keyup.enter.native="doUpdatePassword"
          />
          <span class="show-pwd" @click="showPwd('repeatPassword')">
              <svg-icon
                :icon-class="
                  repeatPasswordType === 'password' ? 'eye' : 'eye-open'
                "
              />
            </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.updatePassword = false">{{ $t('message.sys.admin.cancel') }}</el-button>
        <el-button type="primary" v-loading="loading.updatePassword"
                   @click="doUpdatePassword">{{ $t('message.sys.admin.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Language from '@/components/Language'
import * as sysApi from "@/api/sys";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Language
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'admin',
      'layout'
    ])
  },
  data() {
    const validRepeat = (rule, value, callback) => {
      if (this.updatePassword.newPassword != value) {
        callback(new Error());
      } else {
        callback();
      }
    };
    return {
      newPasswordType: "password",
      repeatPasswordType: "password",
      loading: {logout: false, updatePassword: false},
      updatePassword: {},
      visible: {
        updatePassword: false
      },
      updatePasswordRules: {
        oldPassword: [
          {required: true, trigger: "blur", message: "请输入密码"},
        ],
        newPassword: [
          {required: true, trigger: "blur", message: "请输入新密码"},
        ],
        repeatPassword: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请输入确认密码",
          },
          {
            trigger: ["blur", "change"],
            message: "两次密码不正确",
            validator: validRepeat,
          },
        ],
      },
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    showPwd(name) {
      const key = name + "Type";
      if (this[key] === "password") {
        this[key] = "";
      } else {
        this[key] = "password";
      }
      this.$nextTick(() => {
        this.$refs[name].focus();
      });
    },
    doAction(command) {
      if (command == "logout") {
        this.doLogout();
      } else if (command == "updatePassword") {
        this.visible.updatePassword = true;
      }
    },
    doUpdatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading.updatePassword = true;
        sysApi.adminUpdatePassword(this.updatePassword)
          .then()
          .then(() => {
            this.visible.updatePassword = false;
            this.loading.updatePassword = false;
            window.location.reload();
          })
          .catch(() => {
            this.loading.updatePassword = false;
          });
      });
    },
    doLogout() {
      this.$store.dispatch("sys/logout").then(() => {
        this.$router.push("/login");
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.logo-wrapper {
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 210px;
  height: 100%;

  .logo {
    font-family: "Adobe-Heiti-Std-R";
    height: 45px;

    img {
      height: 100%;
    }
  }

  .title {
    height: 45px;
    font-size: 25px;
    font-weight: 600;
    color: #000000;
    line-height: 45px;
  }
}

.el-dropdown-link {
  font-size: 16px;
  cursor: pointer;
  color: $main-color;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;
  font-size: 16px;
  color: #676a6c;
  cursor: pointer;
  user-select: none;
}

.navbar {
  display: flex;
  justify-content: space-between;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .adv {
    height: 100%;
    line-height: 50px;
    font-weight: bold;
    font-size: 25px;
  }

  .right-menu {
    width: 180px;
    height: 100%;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;


    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.note {
  margin-right: 15px;
  display: flex;
  align-content: center;

  .icon-note {
    font-size: 22px;
    cursor: pointer;
  }
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
}

.popup {
  width: 340px;
  padding: 10px;
  font-size: 14px;
  color: #222;
  min-height: 400px;
  max-height: 400px;
  overflow-y: auto;

  li {
    margin-bottom: 8px;
  }

  h3 {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
  }

  a {
    padding-left: 20px;
    color: #666;
    cursor: pointer;
    padding-bottom: 3px;
  }
}

.dot {
  width: 8px;
  height: 8px;
  background: #ed5f4d;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.information {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-name {
  font-size: 14px;
  color: #222;
  margin-left: 10px;
}

.text-name {
  width: 32px;
  height: 32px;
  background: #d8d8d8;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fefefe;
  font-size: 16px;
}

.lang-wrapper {
  width: 60px;
  display: flex;
  justify-content: flex-end; /* 子元素对齐到容器的右侧 */
}
</style>



// WEBPACK FOOTER //
// src/admin/layout/components/Navbar.vue